import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Sparkle } from "@/components/site/Mark";
import { Reveal } from "@/components/site/Reveal";
import { PRIVACY, CONTACT_EMAIL, mailto } from "@/content";

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Privacy & Confidentiality Notice — 10THCELESTIAL";
    return () => { document.title = "10THCELESTIAL — Where Intuition Meets Intention."; };
  }, []);

  return (
    <section data-testid="privacy-page" className="relative pt-32 sm:pt-44 pb-24 sm:pb-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 font-caps text-xs tracking-[0.25em] uppercase text-[#E2CC92] link-underline">
          <ArrowLeft className="w-3.5 h-3.5" /> Return home
        </Link>
        <p className="mt-12 font-caps text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#C9AD6A] flex items-center gap-3">
          <Sparkle className="w-3 h-3" /> 10THCELESTIAL
        </p>
        <h1 data-testid="privacy-title" className="mt-5 font-display font-light text-5xl sm:text-6xl lg:text-7xl text-[#FAF6ED] leading-[1]">
          Privacy &amp; <span className="italic text-[#C9AD6A]">Confidentiality</span> Notice
        </h1>
        <p className="mt-6 text-sm text-[#FAF6ED]/70 font-body">Effective Date: {PRIVACY.effective}</p>
        <p className="mt-10 font-display italic text-xl sm:text-2xl text-[#FAF6ED]/90 leading-snug">{PRIVACY.intro}</p>
        <div className="mt-14 space-y-12">
          {PRIVACY.sections.map((s, i) => (
            <Reveal key={s.title}>
              <div className="grid sm:grid-cols-[3rem_1fr] gap-2 sm:gap-6 border-t border-[#B59A5B]/20 pt-8">
                <span className="font-display italic text-2xl text-[#B59A5B]/70">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h2 className="font-display text-3xl text-[#FAF6ED]">{s.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-[#FAF6ED]/80 font-body">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <div className="grid sm:grid-cols-[3rem_1fr] gap-2 sm:gap-6 border-t border-[#B59A5B]/20 pt-8">
              <span className="font-display italic text-2xl text-[#B59A5B]/70">{String(PRIVACY.sections.length + 1).padStart(2, "0")}</span>
              <div>
                <h2 className="font-display text-3xl text-[#FAF6ED]">Privacy Inquiries</h2>
                <p className="mt-4 text-base leading-relaxed text-[#FAF6ED]/80 font-body">For privacy-related questions or requests, contact:</p>
                <a href={mailto("Privacy inquiry")} data-testid="privacy-email-link" className="mt-3 inline-block font-display text-2xl text-[#E2CC92] link-underline break-all">{CONTACT_EMAIL}</a>
              </div>
            </div>
          </Reveal>
        </div>
        <p className="mt-16 rounded-2xl border border-[#B59A5B]/25 bg-[#18222D] p-6 text-sm leading-relaxed text-[#FAF6ED]/80 font-body">{PRIVACY.closing}</p>
      </div>
    </section>
  );
}
